// Sales sync nightly and the most recent days still get late orders and edits,
// so the last DAYS_THAT_CAN_CHANGE days of sales are shown as "can still change".
export const DAYS_THAT_CAN_CHANGE = 7
